export const pinTitle = "HtDADb";
export default {pinTitle};